import { createHash } from "crypto";
export async function hashString(inputString) {
    return createHash("sha256").update(inputString.toLowerCase()).digest("hex");
}
